import { AttachmentSource } from "../reducer.types";

export const useMaxAttachmentCount = (source: AttachmentSource) => {
    return 5;
};
